import cookie from 'cookie';

import browser from '../../src/client/utils/browser';
import config from '../../src/client/config';

const COOKIE_KEY = 'gbClientId';

const TIMEOUT_MS = 5000;

let clientIdRequest: Promise<string> | undefined;

export const setAnalyticsClientId = () => {
  if (!clientIdRequest) {
    clientIdRequest = new Promise<string>((resolve) => {
      // this can never resolve if analytics gets blocked (ad blockers, private browsers etc)
      browser.getWindow().gtag('get', config.get('google:analytics:ga4TrackingId'), 'client_id', (clientId: string) => {
        // Store the ga client id in a separate cookie so it can be easily accessed from the
        // server, rather than trying to interrogate the actual _ga cookie (which is not recommended).
        browser.getDocument().cookie = cookie.serialize(COOKIE_KEY, clientId, { path: '/' });
        resolve(clientId);
      });
    });
  }
  return clientIdRequest;
};

export const getAnalyticsClientId = () => {
  const existing = cookie.parse(browser.getDocument().cookie)[COOKIE_KEY];
  if (existing) return Promise.resolve(existing);

  // incase the below setAnalyticsClientId never resolves due to ad blockers, resolve with no value after timeout
  const timeout = new Promise<undefined>((resolve) => {
    setTimeout(resolve, TIMEOUT_MS);
  });

  return Promise.race([setAnalyticsClientId(), timeout]);
};
